import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class SublineApi {
  /**
   * @deprecated Use GetSublinesFilter instead for better performance with server-side pagination.
   */
  static async GetAllSublines(): Promise<any> {
    return ApiHandler(baseURL).get("/v1/sublines/all");
  }

  static async GetSublinesFilter(params: any): Promise<any> {
    return ApiHandler(baseURL).get("/v1/sublines/filter", { params });
  }

  static async GetSublineById(id: string): Promise<any> {
    return ApiHandler(baseURL).get("/v1/sublines/" + id);
  }

  static async GetSublineByLine(lineId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/v1/sublines/line/${lineId}`);
  }

  static async GetSublineByPlant(plantId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/v1/sublines/plant/${plantId}`);
  }

  static async CreateSubline(
    lineId: string,
    description: string,
    name: string,
  ): Promise<any> {
    return ApiHandler(baseURL).post("/v1/sublines", {
      lineId,
      description,
      name,
    });
  }

  static async UpdateSubline(
    id: string,
    lineId: string,
    description: string,
    name: string,
  ): Promise<any> {
    return ApiHandler(baseURL).put(`/v1/sublines/${id}`, {
      lineId,
      description,
      name,
    });
  }

  static async DeleteSubline(sublineId: string): Promise<any> {
    return ApiHandler(baseURL).delete(`/v1/sublines/${sublineId}`);
  }
}
